"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteAccountService = exports.authSuiteAccountService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var expired_token_error_handling_strategy_1 = require("../../error-handlers/expired-token-error-handling-strategy");
var requestRoute = "account";
var getAccountDetails = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: requestRoute,
    });
};
var updateAccountDetails = function (request) {
    var payload = {
        marketingOptIn: request.marketingOptIn,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
        body: body,
        path: requestRoute,
    });
};
var untieMvpdFromAccount = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .delete({
        path: "".concat(requestRoute, "/mvpd"),
    })
        .then(function (response) { return refreshTokenAfterUntieMvpdFromAccount(response); });
};
var refreshTokenAfterUntieMvpdFromAccount = function (response) {
    return expired_token_error_handling_strategy_1.expiredTokenErrorHandlingContext.handleTokenRefresh().then(function () {
        return response;
    });
};
exports.authSuiteAccountService = {
    getAccountDetails: getAccountDetails,
    updateAccountDetails: updateAccountDetails,
    untieMvpdFromAccount: untieMvpdFromAccount,
};
var AuthSuiteAccountService = /** @class */ (function () {
    function AuthSuiteAccountService() {
        return exports.authSuiteAccountService;
    }
    return AuthSuiteAccountService;
}());
exports.AuthSuiteAccountService = AuthSuiteAccountService;
